import { MetaData } from "@/types/feedback.types";
import React from "react";
import PoweredByFooter from "../PoweredByFooter";
import LayoutWrapper from "../LayoutWrapper/LayoutWrapper";
import { useTranslation } from "react-i18next";

interface FormWrapperProps {
  children: React.ReactNode;
  metaData: MetaData;
  showTitle: boolean;
}

const FormWrapper: React.FC<FormWrapperProps> = ({
  children,
  metaData,
  showTitle,
}) => {
  const { t } = useTranslation();

  return (
    <LayoutWrapper>
      <header className="p-4 rounded-3 bg-white">
        {metaData?.companyLogo && (
          <div className="mb-4">
            <img
              src={metaData.companyLogo}
              alt={metaData?.companyName}
              style={{
                maxHeight: 100,
                maxWidth: 200,
              }}
              className="img-fluid"
            />
          </div>
        )}
        {showTitle && (
          <div className="mb-3">
            <h1 className="h2 mb-3 visually-hidden">
              {t("Form.Header.Greeting", {
                firstName: metaData?.recipient?.firstName,
              })}
            </h1>
            <p className="text-muted mb-0 caption">{t("Form.Header.Intro")}</p>
            <p className="text-muted fw-bold fs-6 mb-0">{metaData?.jobTitle}</p>
          </div>
        )}
      </header>
      {children}
      <PoweredByFooter />
    </LayoutWrapper>
  );
};

export default FormWrapper;
